import { useState, useEffect, useRef } from "react";
import { Send, Bot, User, Plus, MessageSquare, Loader2, Dumbbell, Apple, Activity, X, ChevronLeft } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Navbar } from "../components/Navbar";
import { ProtectedRoute } from "../components/ProtectedRoute";
import api from "../lib/api";

const EXERCISE_IMAGES = {
  "push": "https://static.prod-images.emergentagent.com/jobs/1097075e-32a9-4c88-942d-3d6dd2af456f/images/7495e1590fcde8fb2394c9b62ae817700d7c919696708cfe27ea2a869f779fc0.png",
  "squat": "https://static.prod-images.emergentagent.com/jobs/1097075e-32a9-4c88-942d-3d6dd2af456f/images/4c3f967dd205138ee7cd02eee3889e85749f92b96733939a79838e833d1d7fa6.png",
  "plank": "https://static.prod-images.emergentagent.com/jobs/1097075e-32a9-4c88-942d-3d6dd2af456f/images/1971ca810918d9148d0d9c29a302800ea55d8e1f5c6e8ba702dde7671a264620.png",
  "lunge": "https://static.prod-images.emergentagent.com/jobs/1097075e-32a9-4c88-942d-3d6dd2af456f/images/d956fb1780e6945f9d296561be9e7f10404beb19b866d8f888137fcf61d04fde.png",
  "deadlift": "https://static.prod-images.emergentagent.com/jobs/1097075e-32a9-4c88-942d-3d6dd2af456f/images/42bf30c2dbf507b88d8c79c905b4260a824531ab461a4d934f8feea2210f284a.png",
  "bench": "https://static.prod-images.emergentagent.com/jobs/1097075e-32a9-4c88-942d-3d6dd2af456f/images/eb91d0baf8263655db536cb8ac36211c3b44db288a0cdeaf3b7ba3e8e325ae78.png",
  "curl": "https://static.prod-images.emergentagent.com/jobs/1097075e-32a9-4c88-942d-3d6dd2af456f/images/5f92e454c65dea6c7ee7d018996c9e971f256b4f0bb237d09b34887d9c1f2e71.png",
  "jack": "https://static.prod-images.emergentagent.com/jobs/1097075e-32a9-4c88-942d-3d6dd2af456f/images/6db6acd5209fc3e29844a9e1d57f8a20a76065f77fd7cbd78a1d7d89993189f3.png",
  "burpee": "https://static.prod-images.emergentagent.com/jobs/1097075e-32a9-4c88-942d-3d6dd2af456f/images/15dd6abfdd60b3efdd2456f9b7abb80e18f4984b656869b16ba7848e3d228b45.png",
  "mountain": "https://static.prod-images.emergentagent.com/jobs/1097075e-32a9-4c88-942d-3d6dd2af456f/images/9940b741f670e93adcbbc05fd84a79eb86437a48a84720f4271df6f9be1a2834.png",
  "shoulder": "https://static.prod-images.emergentagent.com/jobs/1097075e-32a9-4c88-942d-3d6dd2af456f/images/c2bc78648636d088d49015676042eb54d26793f12752b452aba85ff933e16ae6.png",
  "crunch": "https://static.prod-images.emergentagent.com/jobs/1097075e-32a9-4c88-942d-3d6dd2af456f/images/aeefc5381857354ac262a40195f6fc314fbb78dff9e69c51ec7e2052b3d21625.png",
  "sit": "https://static.prod-images.emergentagent.com/jobs/1097075e-32a9-4c88-942d-3d6dd2af456f/images/aeefc5381857354ac262a40195f6fc314fbb78dff9e69c51ec7e2052b3d21625.png",
  "press": "https://static.prod-images.emergentagent.com/jobs/1097075e-32a9-4c88-942d-3d6dd2af456f/images/c2bc78648636d088d49015676042eb54d26793f12752b452aba85ff933e16ae6.png",
  "default": "https://static.prod-images.emergentagent.com/jobs/1097075e-32a9-4c88-942d-3d6dd2af456f/images/7495e1590fcde8fb2394c9b62ae817700d7c919696708cfe27ea2a869f779fc0.png",
};
const FOOD_IMAGES = {
  "breakfast": "https://static.prod-images.emergentagent.com/jobs/1097075e-32a9-4c88-942d-3d6dd2af456f/images/275ae200b98a6e259f9ccf6099ac5b663825d6ad97955f98a00a7c20689f775e.png",
  "lunch": "https://static.prod-images.emergentagent.com/jobs/1097075e-32a9-4c88-942d-3d6dd2af456f/images/f923b2a790236485759928f5033459cc3d8164bb97ab3bcdaced80ab8926d0d6.png",
  "dinner": "https://static.prod-images.emergentagent.com/jobs/1097075e-32a9-4c88-942d-3d6dd2af456f/images/d670594e49e50edbd60e3d71c35154f7da8cc0fae3ba89a1247ec31afce08b05.png",
  "snack": "https://static.prod-images.emergentagent.com/jobs/1097075e-32a9-4c88-942d-3d6dd2af456f/images/d3695039b6b73798f4db71608c59f81025080408772ec82a06c44e03c64dd01f.png",
  "default": "https://static.prod-images.emergentagent.com/jobs/1097075e-32a9-4c88-942d-3d6dd2af456f/images/f923b2a790236485759928f5033459cc3d8164bb97ab3bcdaced80ab8926d0d6.png",
};

const getExImg = (kw) => { const k = (kw||"").toLowerCase(); return Object.entries(EXERCISE_IMAGES).find(([key]) => k.includes(key))?.[1] || EXERCISE_IMAGES.default; };
const getFoodImg = (time) => { const t = (time||"").toLowerCase(); return Object.entries(FOOD_IMAGES).find(([key]) => t.includes(key))?.[1] || FOOD_IMAGES.default; };

const parseBlocks = (text) => {
  const parts = [];
  let remaining = text;
  const regex = /```json\s*([\s\S]*?)```/g;
  let match, lastIdx = 0;
  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIdx) parts.push({ type: "text", content: remaining.slice(lastIdx, match.index) });
    try { parts.push({ type: "json", data: JSON.parse(match[1]) }); } catch { parts.push({ type: "text", content: match[0] }); }
    lastIdx = match.index + match[0].length;
  }
  if (lastIdx < text.length) parts.push({ type: "text", content: text.slice(lastIdx) });
  return parts.length ? parts : [{ type: "text", content: text }];
};

const FitnessPlanCard = ({ data }) => (
  <div className="bg-white border border-slate-100 rounded-2xl p-5 my-3 shadow-sm" data-testid="fitness-plan-card">
    <div className="flex items-center gap-2 mb-1"><Dumbbell className="h-5 w-5 text-orange-500" /><h4 className="font-['Outfit'] font-semibold text-[#0F172A]">{data.title}</h4></div>
    {data.estimated_timeline && <p className="text-sm text-[#0B6E4F] font-medium mb-3">Est. timeline: {data.estimated_timeline}</p>}
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      {data.exercises?.map((ex, i) => (
        <div key={i} className="bg-slate-50 rounded-xl overflow-hidden" data-testid={`exercise-${i}`}>
          <img src={getExImg(ex.image_keyword || ex.name)} alt={ex.name} className="w-full h-32 object-cover" loading="lazy" />
          <div className="p-3">
            <p className="font-medium text-sm text-[#0F172A]">{ex.name}</p>
            <p className="text-xs text-slate-500">{ex.muscle_group}</p>
            <p className="text-xs text-[#0B6E4F] font-medium mt-1">{ex.sets}x{ex.reps} &bull; Rest {ex.rest}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
);

const MealPlanCard = ({ data }) => (
  <div className="bg-white border border-slate-100 rounded-2xl p-5 my-3 shadow-sm" data-testid="meal-plan-card">
    <div className="flex items-center gap-2 mb-1"><Apple className="h-5 w-5 text-green-500" /><h4 className="font-['Outfit'] font-semibold text-[#0F172A]">{data.title}</h4></div>
    {data.daily_calories && <p className="text-sm text-[#0B6E4F] font-medium mb-3">{data.daily_calories} cal/day target</p>}
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      {data.meals?.map((m, i) => (
        <div key={i} className="bg-slate-50 rounded-xl overflow-hidden" data-testid={`meal-${i}`}>
          <img src={getFoodImg(m.time || m.image_keyword)} alt={m.name} className="w-full h-32 object-cover" loading="lazy" />
          <div className="p-3">
            <p className="text-xs font-medium text-slate-400 uppercase">{m.time}</p>
            <p className="font-medium text-sm text-[#0F172A]">{m.name}</p>
            <p className="text-xs text-slate-500 mt-0.5">{m.description}</p>
            <p className="text-xs text-[#0B6E4F] font-medium mt-1">{m.calories} cal</p>
          </div>
        </div>
      ))}
    </div>
  </div>
);

const BodyAnalysisCard = ({ data }) => (
  <div className="bg-gradient-to-br from-[#0B6E4F] to-[#1B3A5C] text-white rounded-2xl p-5 my-3 shadow-lg" data-testid="body-analysis-card">
    <div className="flex items-center gap-2 mb-3"><Activity className="h-5 w-5" /><h4 className="font-['Outfit'] font-semibold">Body Analysis</h4></div>
    <div className="grid grid-cols-3 gap-3 mb-3">
      <div className="bg-white/10 rounded-xl p-3 text-center"><p className="text-xs text-white/60">BMI</p><p className="text-xl font-bold">{data.bmi}</p></div>
      <div className="bg-white/10 rounded-xl p-3 text-center"><p className="text-xs text-white/60">Body Fat</p><p className="text-xl font-bold">{data.body_fat_estimate}</p></div>
      <div className="bg-white/10 rounded-xl p-3 text-center"><p className="text-xs text-white/60">Type</p><p className="text-lg font-bold capitalize">{data.body_type}</p></div>
    </div>
    <p className="text-sm text-white/80 leading-relaxed">{data.summary}</p>
  </div>
);

const MessageBubble = ({ msg }) => {
  const isUser = msg.role === "user";
  if (isUser) return (
    <div className="flex justify-end mb-4" data-testid="user-message">
      <div className="max-w-[80%] bg-[#0B6E4F] text-white rounded-2xl rounded-br-md px-4 py-3">
        <p className="text-sm leading-relaxed whitespace-pre-wrap">{msg.content}</p>
      </div>
      <div className="ml-2 mt-1 w-8 h-8 rounded-full bg-[#0B6E4F]/10 flex items-center justify-center flex-shrink-0"><User className="h-4 w-4 text-[#0B6E4F]" /></div>
    </div>
  );
  const blocks = parseBlocks(msg.content);
  return (
    <div className="flex mb-4" data-testid="assistant-message">
      <div className="mr-2 mt-1 w-8 h-8 rounded-full bg-amber-50 flex items-center justify-center flex-shrink-0"><Bot className="h-4 w-4 text-amber-600" /></div>
      <div className="max-w-[85%]">
        {blocks.map((b, i) => {
          if (b.type === "json") {
            if (b.data.type === "fitness_plan") return <FitnessPlanCard key={i} data={b.data} />;
            if (b.data.type === "meal_plan") return <MealPlanCard key={i} data={b.data} />;
            if (b.data.type === "body_analysis") return <BodyAnalysisCard key={i} data={b.data} />;
          }
          return <div key={i} className="bg-white border border-slate-100 rounded-2xl rounded-bl-md px-4 py-3 shadow-sm mb-1"><p className="text-sm text-slate-700 leading-relaxed whitespace-pre-wrap">{b.content}</p></div>;
        })}
      </div>
    </div>
  );
};

const ProfileSetup = ({ onSave }) => {
  const [f, setF] = useState({ weight_kg: "", height_cm: "", age: "", gender: "male", fitness_goal: "lose_weight", target_months: 6 });
  const [saving, setSaving] = useState(false);
  const save = async (e) => {
    e.preventDefault(); setSaving(true);
    try { await api.post("/vita-ai/profile", { ...f, weight_kg: parseFloat(f.weight_kg), height_cm: parseFloat(f.height_cm), age: parseInt(f.age), target_months: parseInt(f.target_months) }); onSave(f); } catch (err) { console.error('Error:', err.message || err); }
    setSaving(false);
  };
  return (
    <div className="max-w-md mx-auto bg-white border border-slate-100 rounded-2xl p-6 shadow-sm" data-testid="profile-setup">
      <div className="flex items-center gap-3 mb-6"><div className="bg-amber-500 p-2.5 rounded-xl"><Bot className="h-6 w-6 text-white" /></div><div><h3 className="font-['Outfit'] text-lg font-semibold text-[#0F172A]">Welcome to Vita Coach!</h3><p className="text-sm text-slate-500">Tell me about yourself so I can personalize your experience</p></div></div>
      <form onSubmit={save} className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <div><Label className="text-sm font-medium">Weight (kg)</Label><Input type="number" step="0.1" value={f.weight_kg} onChange={e => setF({...f, weight_kg: e.target.value})} placeholder="75" className="mt-1 h-11 rounded-xl bg-slate-50" data-testid="profile-weight" required /></div>
          <div><Label className="text-sm font-medium">Height (cm)</Label><Input type="number" value={f.height_cm} onChange={e => setF({...f, height_cm: e.target.value})} placeholder="175" className="mt-1 h-11 rounded-xl bg-slate-50" data-testid="profile-height" required /></div>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div><Label className="text-sm font-medium">Age</Label><Input type="number" value={f.age} onChange={e => setF({...f, age: e.target.value})} placeholder="28" className="mt-1 h-11 rounded-xl bg-slate-50" data-testid="profile-age" required /></div>
          <div><Label className="text-sm font-medium">Gender</Label><select value={f.gender} onChange={e => setF({...f, gender: e.target.value})} className="w-full mt-1 h-11 rounded-xl bg-slate-50 border border-slate-200 px-3 text-sm" data-testid="profile-gender"><option value="male">Male</option><option value="female">Female</option><option value="other">Other</option></select></div>
        </div>
        <div><Label className="text-sm font-medium">Fitness Goal</Label><select value={f.fitness_goal} onChange={e => setF({...f, fitness_goal: e.target.value})} className="w-full mt-1 h-11 rounded-xl bg-slate-50 border border-slate-200 px-3 text-sm" data-testid="profile-goal"><option value="lose_weight">Lose Weight</option><option value="gain_muscle">Gain Muscle</option><option value="get_fit">Get Fit / Tone Up</option><option value="improve_health">Improve Overall Health</option></select></div>
        <div><Label className="text-sm font-medium">Target Timeline (months)</Label><Input type="number" value={f.target_months} onChange={e => setF({...f, target_months: e.target.value})} className="mt-1 h-11 rounded-xl bg-slate-50" data-testid="profile-months" /></div>
        <Button type="submit" disabled={saving} data-testid="profile-save-btn" className="w-full h-12 bg-[#0B6E4F] hover:bg-[#095A40] text-white rounded-full font-semibold">{saving ? "Saving..." : "Start Chatting"}</Button>
      </form>
    </div>
  );
};

const QUICK_PROMPTS = [
  { label: "Analyze my body", msg: "Based on my profile, analyze my body — estimate my body fat percentage, body type, and BMI. Give me honest feedback." },
  { label: "Create workout plan", msg: "Create a personalized weekly workout plan for me based on my goals. Include exercise visuals." },
  { label: "Create meal plan", msg: "Create a daily meal plan for me with breakfast, lunch, dinner and snacks. Include calories and food visuals." },
  { label: "Estimate my timeline", msg: "Based on my current stats and goals, how long will it realistically take me to reach my target? What results can I expect month by month?" },
];

const VitaCoachContent = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [sending, setSending] = useState(false);
  const [sessionId, setSessionId] = useState("");
  const [sessions, setSessions] = useState([]);
  const [showSidebar, setShowSidebar] = useState(false);
  const chatEnd = useRef(null);

  useEffect(() => {
    Promise.all([
      api.get("/vita-ai/profile").catch(() => ({ data: {} })),
      api.get("/vita-ai/chat/sessions").catch(() => ({ data: [] })),
    ]).then(([p, s]) => {
      if (p.data?.weight_kg) setProfile(p.data);
      setSessions(s.data || []);
      setLoading(false);
    });
  }, []);

  useEffect(() => { chatEnd.current?.scrollIntoView({ behavior: "smooth" }); }, [messages]);

  const sendMessage = async (text) => {
    if (!text.trim() || sending) return;
    const userMsg = { role: "user", content: text };
    setMessages(prev => [...prev, userMsg]);
    setInput(""); setSending(true);
    try {
      const res = await api.post("/vita-ai/chat", { message: text, session_id: sessionId });
      if (!sessionId) setSessionId(res.data.session_id);
      setMessages(prev => [...prev, { role: "assistant", content: res.data.response }]);
      api.get("/vita-ai/chat/sessions").then(s => setSessions(s.data || [])).catch(() => {});
    } catch (err) {
      setMessages(prev => [...prev, { role: "assistant", content: "Sorry, I had trouble responding. Please try again." }]);
    }
    setSending(false);
  };

  const loadSession = async (sid) => {
    try {
      const res = await api.get(`/vita-ai/chat/history?session_id=${sid}`);
      setMessages(res.data || []);
      setSessionId(sid);
      setShowSidebar(false);
    } catch (err) { console.error('Error:', err.message || err); }
  };

  const newChat = () => { setMessages([]); setSessionId(""); setShowSidebar(false); };

  if (loading) return <div className="min-h-screen bg-transparent"><Navbar /><div className="flex justify-center py-20"><Loader2 className="h-8 w-8 animate-spin text-[#0B6E4F]" /></div></div>;

  return (
    <div className="min-h-screen bg-transparent flex flex-col" data-testid="vita-coach-page">
      <Navbar />
      {!profile ? (
        <div className="flex-1 flex items-center justify-center px-4 py-12"><ProfileSetup onSave={setProfile} /></div>
      ) : (
        <div className="flex-1 flex max-w-6xl mx-auto w-full relative">
          {/* Sidebar */}
          <div className={`${showSidebar ? "translate-x-0" : "-translate-x-full md:translate-x-0"} fixed md:static inset-y-0 left-0 z-40 w-72 bg-white border-r border-slate-100 flex flex-col transition-transform`}>
            <div className="p-4 border-b border-slate-100">
              <Button onClick={newChat} data-testid="new-chat-btn" className="w-full bg-[#0B6E4F] hover:bg-[#095A40] text-white rounded-full font-semibold"><Plus className="mr-2 h-4 w-4" /> New Chat</Button>
            </div>
            <div className="flex-1 overflow-y-auto p-2">
              {sessions.map((s, i) => (
                <button key={s.session_id} onClick={() => loadSession(s.session_id)} data-testid={`session-${i}`} className={`w-full text-left px-3 py-2.5 rounded-xl text-sm mb-1 transition-colors ${sessionId === s.session_id ? "bg-[#F2F9F6] text-[#0B6E4F]" : "hover:bg-slate-50 text-slate-600"}`}>
                  <div className="flex items-center gap-2"><MessageSquare className="h-3.5 w-3.5 flex-shrink-0" /><span className="truncate">{s.last_message}</span></div>
                </button>
              ))}
            </div>
            <button onClick={() => setShowSidebar(false)} className="md:hidden absolute top-4 right-4 p-1"><X className="h-5 w-5" /></button>
          </div>
          {showSidebar && <div className="fixed inset-0 bg-black/30 z-30 md:hidden" onClick={() => setShowSidebar(false)} />}

          {/* Chat Area */}
          <div className="flex-1 flex flex-col min-w-0">
            <div className="flex items-center gap-3 px-4 md:px-6 py-3 border-b border-slate-100 bg-white">
              <button onClick={() => setShowSidebar(true)} className="md:hidden p-1.5 hover:bg-slate-100 rounded-lg"><ChevronLeft className="h-5 w-5" /></button>
              <div className="w-9 h-9 bg-amber-50 rounded-full flex items-center justify-center"><Bot className="h-5 w-5 text-amber-600" /></div>
              <div><h3 className="font-['Outfit'] font-semibold text-[#0F172A] text-sm">Vita Coach</h3><p className="text-xs text-slate-400">Your personal AI fitness coach</p></div>
            </div>

            <div className="flex-1 overflow-y-auto px-4 md:px-6 py-6" data-testid="chat-messages">
              {messages.length === 0 && (
                <div className="text-center py-12">
                  <div className="w-16 h-16 bg-amber-50 rounded-full flex items-center justify-center mx-auto mb-4"><Bot className="h-8 w-8 text-amber-500" /></div>
                  <h3 className="font-['Outfit'] text-xl font-semibold text-[#0F172A] mb-2">Hey there! I'm your Vita Coach</h3>
                  <p className="text-sm text-slate-500 max-w-md mx-auto mb-8">I can create workout plans, meal plans, analyze your body composition, or just chat about your fitness journey.</p>
                  <div className="flex flex-wrap justify-center gap-2">
                    {QUICK_PROMPTS.map((p, i) => (
                      <button key={p.label} onClick={() => sendMessage(p.msg)} data-testid={`quick-prompt-${i}`} className="px-4 py-2 bg-white border border-slate-200 rounded-full text-sm text-slate-600 hover:border-[#0B6E4F] hover:text-[#0B6E4F] transition-colors">{p.label}</button>
                    ))}
                  </div>
                </div>
              )}
              {messages.map((m, i) => <MessageBubble key={`${m.role}-${i}-${m.content?.slice(0,10)}`} msg={m} />)}
              {sending && (
                <div className="flex mb-4"><div className="mr-2 mt-1 w-8 h-8 rounded-full bg-amber-50 flex items-center justify-center"><Bot className="h-4 w-4 text-amber-600" /></div><div className="bg-white border border-slate-100 rounded-2xl px-4 py-3 shadow-sm"><div className="flex gap-1.5"><span className="w-2 h-2 bg-slate-300 rounded-full animate-bounce" /><span className="w-2 h-2 bg-slate-300 rounded-full animate-bounce" style={{animationDelay:"0.15s"}} /><span className="w-2 h-2 bg-slate-300 rounded-full animate-bounce" style={{animationDelay:"0.3s"}} /></div></div></div>
              )}
              <div ref={chatEnd} />
            </div>

            <div className="px-4 md:px-6 py-4 border-t border-slate-100 bg-white">
              <form onSubmit={(e) => { e.preventDefault(); sendMessage(input); }} className="flex gap-3">
                <Input value={input} onChange={(e) => setInput(e.target.value)} placeholder="Ask your coach anything..." className="flex-1 h-12 rounded-full bg-slate-50 border-slate-200 px-5" data-testid="chat-input" disabled={sending} autoFocus />
                <Button type="submit" disabled={sending || !input.trim()} data-testid="chat-send-btn" className="h-12 w-12 rounded-full bg-[#0B6E4F] hover:bg-[#095A40] text-white p-0"><Send className="h-5 w-5" /></Button>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default function VitaCoach() {
  return <ProtectedRoute><VitaCoachContent /></ProtectedRoute>;
}
